import { Component, Input } from '@angular/core';
import { DateHelper } from '../../../../helpers/date.helper';

@Component({
  standalone: false,
  selector: 'app-employee-availability',
  templateUrl: './employee-availability.component.html',
  styleUrls: ['../availability.component.scss']
})

export class EmployeeAvailabilityComponent {
  @Input() availability: any;
  @Input() singleOrder: boolean;

  isOpen: boolean;

  constructor(public dateHelper: DateHelper) {
  }

  onToggle(): void {
    this.isOpen = !this.isOpen;
  }

  trackByFn(index: number): number {
    return index;
  }
}
